export interface AccountBannerPreference {
    visibility: AccountBannerPreferenceVisibility;
}

export enum AccountBannerPreferenceVisibility {
    SHOW = "show",
    HIDE = "hide",
    SHOW_IF_MULTIPLE_DELEGATORS = "show_if_multiple_delegators",
}
